export default "__VITE_ASSET__C1cAx4K$__"